import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementWebformTime'], () => {
  return {
    $formkit: 'time',
  }
})
